var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('HeroSection'),_c('SpeakersSection'),_c('AgendaHighlights'),_c('TicketPricing'),_c('OneTicket3Shows'),_c('About'),_c('Newsletter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }